import { useGoogleLogin, UseGoogleLoginOptionsAuthCodeFlow } from '@react-oauth/google'

export function useLoginWithGoogle() {
    function libraryLoginWithGoogle(options: Omit<UseGoogleLoginOptionsAuthCodeFlow, 'redirect_uri' | 'flow'>) {
        return useGoogleLogin({
            redirect_uri: import.meta.env.VITE_GOOGLE_REDIRECT_URL,
            flow: 'auth-code',
            ...options
        })
    }

    return libraryLoginWithGoogle
}
